var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15413_13729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.43972 0 0 4.43972 0 10C0 15.5603 4.43972 20 10 20C15.5603 20 20 15.4752 20 10C20 4.52482 15.4752 0 10 0ZM13.2766 12.0993C13.1206 13.1773 12.1986 14.0426 11.0071 14.3404V15.5319C11.0071 16.0426 10.5957 16.4539 10.0851 16.4539C9.57447 16.4539 9.16312 16.0426 9.16312 15.5319V14.3404C7.97163 14.0709 7.13475 13.3617 7.02128 13.2624C6.6383 12.922 6.59575 12.3404 6.93617 11.9574C7.2766 11.5745 7.85816 11.5319 8.24114 11.8723C8.24114 11.8723 9.0922 12.5957 10.0851 12.5957C10.9078 12.5957 11.4043 12.1418 11.4468 11.8156C11.4894 11.461 11.0213 10.9504 9.82979 10.6241C7.61702 10 6.97872 8.6383 7.12057 7.58865C7.26241 6.58156 8.07092 5.78723 9.14894 5.50355V4.43972C9.14894 3.92908 9.56028 3.51773 10.0709 3.51773C10.5816 3.51773 10.9929 3.92908 10.9929 4.43972V5.50355C12.1135 5.80142 12.7943 6.53901 12.8794 6.6383C13.2057 7.02128 13.1631 7.60284 12.7801 7.94326C12.3972 8.2695 11.8156 8.22695 11.4894 7.84397C11.461 7.80142 10.922 7.21986 10.0709 7.21986C9.3617 7.21986 8.97872 7.58865 8.93617 7.84397C8.89362 8.12766 9.30497 8.56738 10.3121 8.85106C13.3333 9.71631 13.3333 11.5319 13.2482 12.0709L13.2766 12.0993Z",
    fill: "#54FF99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15413_13729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashback);
export default __webpack_public_path__ + "static/media/cashback.848cb773cb8ada2925956a6cb6e85573.svg";
export { ForwardRef as ReactComponent };